// Minimal in-process event bus so admin writes can notify frontend
// sections (and other admin panels) to re-read data without a full
// page reload. Write paths call emitCmsChange(scope); readers register a
// listener with subscribeCmsChange(listener) and filter on the scopes they
// care about inside that listener — there is no per-scope subscribe helper.
// Current subscribers: useResource + useConfig (lib/siteData.ts) and
// useArticles (lib/articles.ts).

type Scope =
  | 'all'
  | 'articles'
  | 'services'
  | 'offers'
  | 'projects'
  | 'testimonials'
  | 'experience'
  | 'certifications'
  | 'speaking-events'
  | 'thought-leadership'
  | 'social-links'
  | 'service-pages'
  | 'media'
  | 'content'
  | 'config'
  | 'leads'
  | 'audit'
  | 'conversations';

type Listener = (scope: Scope) => void;
const listeners = new Set<Listener>();

export function emitCmsChange(scope: Scope) {
  for (const l of Array.from(listeners)) {
    try { l(scope); } catch (err) { console.error('[cmsEvents] listener error', err); }
  }
  // Cross-tab signal
  try { localStorage.setItem('ck_cms_bump', `${scope}:${Date.now()}`); } catch { /* ignore */ }
}

export function subscribeCmsChange(listener: Listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key !== 'ck_cms_bump' || !e.newValue) return;
    const [scope] = e.newValue.split(':');
    for (const l of Array.from(listeners)) {
      try { l(scope as Scope); } catch { /* noop */ }
    }
  });
}
